export default {"src":"/_next/static/media/arrow-narrow-up.497fa8a2.svg","height":14,"width":15};